module.exports = __webpack_public_path__ + "img/banner images.b09fa837.png";